import classnames from 'classnames'
import PropTypes  from 'prop-types'
import React      from 'react'

import { GENERATE_UUID } from '../../utilities'

/**
 * TODO: TextField component
 *
 * @param {*} props
 * @returns
 */
export const TextField = ( props ) => {
  // const [value, setValue] = useState(props.value)
  const {
          label,
          id,
          disabled,
          fieldClasses,
          containerClasses,
          labelClasses,
          wrapperClasses,
          placeholder,
          onChange,
          onBlur,
          type,
          errorField,
          errorMessage,
          name,
          value,
          min,
          max,
          step,
          percentMark,
          poundMark,
          poundMarkClasses
        } = props

  // Use custom id or the default
  const componentId = id || GENERATE_UUID()

  const asTextMarkup = () => (
    <div className={ wrapperClasses ?? classnames( 'relative z-0 w-full group', { 'bg-red-200': errorMessage || errorField } ) }>
      <input
        disabled={ props.disabled }
        required={ props.isRequired }
        type={ type }
        name={ name }
        value={ value }
        placeholder={ placeholder }
        id={ componentId }
        onChange={ ( { target } ) => onChange( target.value ) }
        //onBlur={onBlur}
        autoFocus={ props.autoFocus }
        autoComplete={ props.autoComplete }
        className={ fieldClasses ?? classnames(
          'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer',
          { 'border-red-600': errorField === name }
        ) }
      />
      <label
        htmlFor={ componentId }
        className={ labelClasses ?? 'peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6' }
      >
        { label }
      </label>
    </div>
  )

  const asNumberMarkup = () => (
    <div className={ wrapperClasses ?? classnames( 'relative z-0 w-full group', { 'bg-red-200': errorMessage || errorField } ) }>
      { poundMark &&
        <span className={ poundMarkClasses ?? 'absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-900' }>&pound;</span>
      }
      <input
        onWheel={ e => e.target.blur() }
        disabled={ props.disabled }
        required={ props.isRequired }
        type={ type }
        name={ name }
        value={ value }
        placeholder={ placeholder }
        id={ componentId }
        min={ min ?? 0 }
        max={ max ?? 1000000 }
        step={ step ?? 1 }
        onChange={ ( { target } ) => onChange( target.value ) }
        //onBlur={onBlur}
        autoFocus={ props.autoFocus }
        autoComplete={ props.autoComplete }
        className={ fieldClasses ?? classnames(
          'block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer',
          { 'border-red-600': errorField === name }
        ) }
      />
      { percentMark &&
        <span className="absolute right-6 top-1/2 transform -translate-y-1/2 text-gray-900">%</span>
      }
      <label
        htmlFor={ componentId }
        className={ labelClasses ?? 'peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6' }
      >
        { label }
      </label>
    </div>
  )

  const asTextAreaMarkup = () => (
    <div>
      <label htmlFor={ componentId } className={ labelClasses ?? 'block mb-2 text-sm font-medium text-gray-900 dark:text-white' }>
        { label }
      </label>
      <textarea
        disabled={ props.disabled }
        required={ props.isRequired }
        name={ name }
        placeholder={ placeholder }
        id={ componentId }
        onChange={ ( { target } ) => onChange( target.value ) }
        //onBlur={onBlur}
        value={ value }
        className={ fieldClasses ?? 'block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500' }
      />
    </div>
  )

  return (
    <div className={ containerClasses ?? 'flex-1' }>
      { props.type === 'textarea' ? asTextAreaMarkup() : props.type === 'number' ? asNumberMarkup() : asTextMarkup() }
      { !fieldClasses &&
        <p className={ classnames( 'text-sm mt-1 h-[3px]', {
          'visible text-red-600': errorMessage,
          invisible:              !errorMessage
        } ) }>{ errorMessage }</p>
      }
    </div>
  )
}

TextField.defaultProps = {
  placeholder: ' ',
  value:       '',
  min: 0,
  max: 999999999,
  step: 1,
  isRequired:  false,
  percentMark: false,
  poundMark:   false,
  autoFocus:   false,
  disabled:    false
}

TextField.propTypes = {
  disabled:         PropTypes.bool,
  autoFocus:        PropTypes.bool,
  autoComplete:     PropTypes.string,
  label:            PropTypes.string.isRequired,
  name:             PropTypes.string.isRequired,
  placeholder:      PropTypes.string,
  wrapperClasses:   PropTypes.string,
  poundMarkClasses: PropTypes.string,
  fieldClasses:     PropTypes.string,
  labelClasses:     PropTypes.string,
  containerClasses: PropTypes.string,
  errorMessage:     PropTypes.string,
  isRequired:       PropTypes.bool,

  /** Should be the same name as `name` prop */
  errorField: PropTypes.string,

  id: PropTypes.oneOfType( [
    PropTypes.string,
    PropTypes.number
  ] ),
  //autoComplete: PropTypes.oneOf(['off']),
  type:     PropTypes.oneOf( [ 'text', 'textarea', 'email', 'password', 'email', 'number', 'tel' ] ).isRequired,
  value:    PropTypes.string,
  onChange: PropTypes.func,
  onBlur:   PropTypes.func
}
